// extracted by mini-css-extract-plugin
module.exports = {"buttonsWrapper":"styles_buttonsWrapper__AyNGS","normalButton":"styles_normalButton__28d7D"};